import Header from '../components/Header'
import Footer from '../components/Footer'
import Contact from '../components/Contact'

const ContactPage = () => {
  const breadcrumbs = [
    { label: 'ホーム', to: '/' },
    { label: 'お問い合わせ' },
  ]

  return (
    <>
      <Header breadcrumbs={breadcrumbs} />
      <main>
        <section className="page-hero">
          <div className="container">
            <p className="section-pretitle">CONTACT</p>
            <h1 className="page-hero-title">お問い合わせ</h1>
            <p className="page-hero-lead">
              ご質問やご相談がございましたら、お気軽にお問い合わせください。<br />
              ITビジネスの未来を共に創るパートナーとして、誠心誠意対応させていただきます。
            </p>
          </div>
        </section>
        <div className="page-content">
          <Contact />
        </div>
      </main>
      <Footer />
    </>
  )
}

export default ContactPage
